<template>
    <select
        :disabled="disabled"
        :class="{ 'border-gray-200': disabled, 'border-gray-300': !disabled }"
        class="
            form-select
            focus:border-indigo-300
            focus:ring
            focus:ring-indigo-200
            focus:ring-opacity-50
            rounded-md
            shadow-sm
        "
        @change="$emit('update:modelValue', $event.target.value)"
    >
        <option
            v-for="(text, index) in opts"
            :key="index"
            :value="index"
            :selected="index === modelValue"
            :disabled="text === disabled_option_index"
        >
            {{ text }}
        </option>
    </select>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    props: ["options", "modelValue", "disabled"],
    emits: ["update:modelValue"],
    data() {
        return {
            opts: {},
            disabled_option_index: null,
        };
    },
    mounted() {
        if (!Array.isArray(this.options)) {
            _.forEach(this.options, (text, index) => {
                this.opts[index] = text;
            });
        } else {
            _.forEach(this.options, (text) => {
                this.opts[text] = text;
                if (text === "") {
                    // "" MEANS DISABLED SELECT
                    this.disabled_option_index = text;
                }
            });
        }
    },
    watch: {
        options: {
            handler(newValue, oldValue) {
                this.opts = {};
                if (!Array.isArray(this.options)) {
                    _.forEach(this.options, (text, index) => {
                        this.opts[index] = text;
                    });
                } else {
                    _.forEach(this.options, (text) => {
                        this.opts[text] = text;
                    });
                }
            },
        },
    },
});
</script>
